const PurpleBorderButton = ({label, width, onClick}) => {
    return (
        <button type="button" style={{minWidth: width ? width : null}} className="button purple-border-button" onClick={onClick}>{label}</button>
    );
}

export default PurpleBorderButton;